import { createFileRoute, Outlet } from "@tanstack/react-router";

/** The wallets: the list, and one wallet's page. */
export const Route = createFileRoute("/_app/money/wallets")({
  component: Outlet,
});
